type DraftSaver = () => Promise<void>

let pendingSaver: DraftSaver | null = null

export function registerPendingDraftSaver(saver: DraftSaver): () => void {
  pendingSaver = saver
  return () => {
    if (pendingSaver === saver) {
      pendingSaver = null
    }
  }
}

export async function runPendingDraftSave(): Promise<void> {
  if (!pendingSaver) return
  try {
    await pendingSaver()
  } catch (error) {
    console.error("[pending-draft-save] Failed to save draft:", error)
  }
}
